import CollapseableTable from '../../../../../../../components/_shared/Table/CollapsableTable'
import GridEventsTable from './GridEventsTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import { columns, mobileColumns } from './Column'
import { useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'
import ReportFooter from '../../ReportsFooter/ReportFooter'

const UserListTable = ({ UserListTableData, downloadExcel, downloadPDF, isLoading, reportData, reportCode, reportTableData, generatePDFFunction }) => {
    const size = useWindowSize();
    const [currentRow, setCurrentRow] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalDevices, setTotalDevices] = useState(0);
    useEffect(() => {
        if (UserListTableData) {
            setTotalUsers(UserListTableData.length);
            const total = UserListTableData
                ?.map(user => user?.devices_array?.length)
                ?.reduce((acc, length) => acc + length, 0);

            setTotalDevices(total)
        }
    }, [UserListTableData])
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">User List</h1>

                <CollapseableTable
                    isLoading={isLoading}
                    data={UserListTableData}
                    columns={mobileColumns}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    renderTable={() => (
                        <GridEventsTable data={UserListTableData} />
                    )} // Pass footerData here
                />
                <div className=" p-6 rounded-lg shadow-md border newReport my-3">
                    <div className="space-y-2 clrText">
                        <div className="d-flex gap-2  justify-between items-center p-3  rounded-md  userListReport">
                            <span className="text-lg font-medium ">
                                Total Users:
                            </span>
                            <span className="text-lg font-semibold ">
                                {totalUsers}
                            </span>
                        </div>
                        <div className="d-flex gap-2  justify-between items-center p-3  rounded-md  userListReport">
                            <span className="text-lg font-medium ">
                                Total Devices:
                            </span>
                            <span className="text-lg font-semibold ">
                                {totalDevices}
                            </span>
                        </div>
                        <div className="d-flex gap-2  justify-between items-center p-3  rounded-md  userListReport">
                            <span className="text-lg font-medium ">
                                Average Devices Per User:
                            </span>
                            <span className="text-lg font-semibold ">
                                {totalDevices / totalUsers}
                            </span>
                        </div>
                    </div>
                </div>
                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF} 
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    generatePDFFunction={generatePDFFunction}
                />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-4">User List</h1>

            <CollapseableTable
                isLoading={isLoading}
                data={UserListTableData}
                columns={columns}
                setCurrentRow={setCurrentRow}
                currentRow={currentRow}
                renderTable={(rowData) => <GridEventsTable data={rowData?.data?.devices_array} />} // Pass footerData here

            />
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
                <div className="space-y-2">
                    <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md shadow-sm">
                        <span className="text-lg font-medium text-gray-700">Total Users: </span>
                        <span className="text-lg font-semibold text-blue-600">{totalUsers}</span>
                    </div>
                    <div className="d-flex gap-2  justify-between items-center p-3  rounded-md  userListReport">
                        <span className="text-lg font-medium ">
                            Total Devices:
                        </span>
                        <span className="text-lg font-semibold ">
                            {totalDevices}
                        </span>
                    </div>
                    <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md shadow-sm">
                        <span className="text-lg font-medium text-gray-700">Average Devices Per User: </span>
                        <span className="text-lg font-semibold text-blue-600">{totalDevices / totalUsers||0}</span>
                    </div>
                </div>
            </div>
            {/* {!UserListTableData && !isLoading && (
                <Alert variant={'danger'} className="my-4" dismissible>
                    No Record Found
                </Alert>
            )} */}

            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={reportTableData}
                generatePDFFunction={generatePDFFunction}
            />
        </>
    )
}

export default UserListTable
